<template>
	<view>
		<!-- 通用提示框 -->
		<dy-dialog ref="dialog"></dy-dialog>
		
		<!-- 空间不足弹窗 -->
		<dy-dialog ref="storage" v-slot="props">
			<div v-if="props.data.storage">
				<div class="title">空间容量不足，无法添加更多文件</div>
				<div class="storage-info">
					<div>请在作品管理列表中删除一些不必要的作品，以释放空间。</div>
					<div>或升级增值服务</div>
					<div class="storage-button">
						<div @click="props.data.storage.goProject">去管理作品</div>
						<div @click="props.data.storage.goShop">去查看增值服务</div>
					</div>
				</div>
			</div>
		</dy-dialog>
		
		<!-- 空间不足弹窗2 -->
		<dy-dialog ref="storage2" v-slot="props">
			<div v-if="props.data.storage">
				<div class="title">所选文件超出空间总容量，无法添加</div>
				<div class="storage-info">
					<div>请压缩文件大小后再试，或升级增值服务</div>
					<div class="storage-button">
						<div @click="props.data.storage.goShop">去查看增值服务</div>
					</div>
				</div>
				
			</div>
		</dy-dialog>
		
		<!-- 正在生成弹窗 -->
		<dy-dialog ref="build" v-slot="props">
			<div style="text-align:center;" v-if="props.data.build">
				<div v-if="props.data.build.percent<1 && props.data.build.status<3">
					  <div class="load-container">
					    <div class="loader-bounce"></div>
					  </div>
				</div>
				
				<div class="build-status-icon iconfont "
					:class="props.data.build.status==3 ? 'icon-success-filled' : 'icon-error-filled'"
					v-if="props.data.build.status>=3"></div>
				
				<div class="build-status-tips" v-if="props.data.build.status>=3">
					<div class="build-status-title">{{ props.data.build.status==3 ? '模型生成成功': '模型生成失败'}}</div>
					{{props.data.build.status==3?'可以在作品编辑中继续完善作品。':(props.data.build.msg ? props.data.build.msg :'如果重试后仍然失败，请重新上传正确的模型。')}}
				</div>
				<div class="build-status-title" v-else>{{ props.data.build.percent ? props.data.build.msg : '正在生成中，请勿操作'}}</div>
				
				<div class="build-progress" v-if="props.data.build.percent>0 && props.data.build.percent <1 && props.data.build.status<3"
					:style="'background:linear-gradient(to right, #7d65f8 0%, #3999ca '+(props.data.build.percent*100)+'%, #181818 '+(props.data.build.percent*100+0.1)+'%);'"></div>
			</div>
		</dy-dialog>
			
			
		<!-- 非法文件弹框 -->
		<dy-dialog ref="files" v-slot="props">
			<div style="height:100%">
				<div v-for="file in props.data.files" class="file-item" >
					<div class="file-item-name">{{file.name}}</div>
					<div class="file-item-text">{{file.text}}</div>
				</div>
			</div>
		</dy-dialog>
		
		<!-- 创建联系人弹窗 -->
		<dy-dialog ref="contact" v-slot="props">
			<div class="dialog-contact" v-if="props.data.contact">
				<div>
					<div class="contact-face" :style="props.data.contact.url ? 'background-image:url('+props.data.contact.url+')':''">
						<span v-if="!props.data.contact.url" class="iconfont icon-me"></span>
						<div v-if="props.data.progress>0&&!props.data.contact.url">{{props.data.progress}}%</div>
					</div>
					<dy-button class="active" style="width:100px;margin:auto;" @click="props.data.upload">上传头像</dy-button>
					<div class="contact-text">尺寸:100 x 100</div>
				</div>
				<div class="right-body-box">
					<div class="contact-input-box">
						<dy-input class="contact-input" 
							maxlength="50" 
							v-model="props.data.contact.name" 
							placeholder="请输入姓名/称呼" 
							@input="(props.data.contact.name.length>0 && props.data.contact.phone.length>0) ? $refs.contact.enableConfirm() : $refs.contact.disableConfirm()" />
					</div>
					<div class="contact-input-box">
						<dy-input class="contact-input" 
							maxlength="50" 
							v-model="props.data.contact.phone" 
							placeholder="请输入电话号码"
							@input="(props.data.contact.name.length>0 && props.data.contact.phone.length>0) ? $refs.contact.enableConfirm() : $refs.contact.disableConfirm()"/>
					</div>
				</div>
			</div>
		</dy-dialog>
		
		<!-- 发布确认弹窗 -->
		<dy-dialog ref="publish" v-slot="props">
			<div class="publish-main" v-if="props.data.publish">
				<div class="title" style="margin-bottom: 20px;font-size: 14px;font-weight:bold;">作品名称：{{props.data.publish.name}}</div>
				<div>
					<div class="title" style="margin-bottom: 5px;font-size: 14px;font-weight:bold;">工具版本：{{props.data.publish.versionText}}</div>
					<!-- 判断条件需要保留，在未设置收费功能时不提示 -->
					<div v-if="props.data.publish.vip<=1 &&(dyConfig.data.buttons.length>0||parseInt(dyConfig.data.init.showLogo)!=1)" class="content" style="color: rgb(99, 120, 231);margin-top: 0;font-weight:500">
						你所设置的收费功能项，不会发布到正式作品中，要包含完整功能，请开通
						<span style="cursor: pointer;color: rgb(99, 120, 231);" @click="props.data.shop">"专业版会员"</span></div>
				</div>
				
				<!-- <div style="margin-top: 40px;">
					<div class="title">上一版本发布时间：{{config.publish_time?formatTime(config.publish_time):'项目还未发布'}}</div>
					<div class="content" style="color: #909090;">注：发布作品会覆盖上一版本的内容，且无法回滚，请谨慎操作。</div>
				</div> -->
				
				<div style="margin-top: 20px;">
					<div class="content" style="font-size: 14px;font-weight:bold;">
						作品分类：{{props.data.publish.type==0 ? '' : props.data.publish.typeName}}
						<span v-if="props.data.publish.typeName" style="cursor: pointer;color: rgb(99, 120, 231);margin: 0 5px;" @click="props.data.publish.showBaseDialog"> 编辑作品信息 </span>
						<span v-if="!props.data.publish.typeName">
							<span style="color: #909090;">未填写</span>
							<span style="cursor: pointer;color: rgb(99, 120, 231);margin: 0 5px;" @click="props.data.publish.showBaseDialog"> 编辑作品信息 </span>
							<div style="color: rgb(99, 120, 231);font-size: 12px;font-weight:500;margin-top: 5px;" > 未填写分类无法进行作品发布 </div>
						</span>
					</div>
				</div>
			</div>
		</dy-dialog>
		
		<!-- 选择图标弹窗 -->
		<dy-dialog ref="icons" v-slot="props">
			<!-- <div class="hotspot-icons"> -->
				<div class="hotspot-icons-types">
					<div class="hotspot-icons-types-row" v-if="IconArr.groups(props.data.type).length>1">
						类别：
						<div class="icons_span_box">
							<span v-for="(item,index) in IconArr.groups(props.data.type)"
								:class="{'icon-span-active':props.data.group == index}"
								@click="props.data.group=index;props.data.index=0">{{item}}</span>
						</div>
					</div>
					
					<div class="hotspot-icons-types-row" >
						类型：
						<div class="icons_span_box">
							<span :class="{'icon-span-active':!props.data.filter}" @click="props.data.filter=0;props.data.index=0">全部</span>
							<span :class="{'icon-span-active':props.data.filter == 1}" @click="props.data.filter=1;props.data.index=0">静态图标</span>
							<span :class="{'icon-span-active':props.data.filter == 2}" @click="props.data.filter=2;props.data.index=0">动态图标</span>
						</div>
					</div>
				</div>
				<div class="all-icon-box" >
					<div
						v-for="(item, index) in IconArr.icons(props.data.type, props.data.group, props.data.filter)"
						:class="{ 
							icon	: true, 
							frame	: item.frame>1,
							active	: props.data.index == index,
						}" 
						@click="props.data.index=index; props.data.selectIcon(item, index)">
						<span
							:style="{
								'background-image'		: 'url('+item.url+')',
								//'background-size'	: 'auto ' + (100/item.frame)+'%'
							}">
						</span>
					</div>
				</div>
			<!-- </div> -->
		</dy-dialog>
		
		<!-- ai生成订单弹窗 -->
		<dy-dialog ref="aiOrder" v-slot="props">
			<div class="pub-item">
				<div class="ai-order-title">
					<span>订单详情：</span>
					<span class="ai-order-title-info">选择要生成的场景：</span>
					<span><dy-button class="ai-select-pano" @click="props.data.selectPano">选择场景</dy-button></span>
					
					<span class="ai-order-title-info">选择参考点：</span>
					<span><dy-button class="ai-select-pano" @click="props.data.selectOrigin">{{props.data.origin||"自动选择"}}</dy-button></span>
				</div>
				<div class="ai-order">
					<div>您选择了<span class="pay-number">{{props.data.panoCount}}</span>个场景</div>
					<div>预计花费
						<span class="pay-number">{{props.data.payNumber}}</span>点数
						<span style="font-size:12px; color:#909090">（以最终生成结果为准）</span>
					</div>
				</div>
				
				<div class="ai-order-title">
					<span>支付方式：</span>
				</div>
				
				<div class="ai-balance">
					<span style="margin-left:10px">DB余额</span>
					<div class="pay-radiobox" :class="{active:props.data.payType==0}" @click="props.data.payType=0">
						常规：<span class="pay-balance">{{props.data.balance.amount}}</span>
					</div>
					<div class="pay-radiobox" :class="{active:props.data.payType==2}" @click="props.data.payType=2">
						包月：<span class="pay-balance">{{props.data.balance.month}}</span>
					</div>
					<div class="pay-radiobox" :class="{active:props.data.payType==1}" @click="props.data.payType=1">
						免费：<span class="pay-balance">{{props.data.balance.free}}</span>
					</div>
					<div>
						<dy-button class="buy-score active" @click="props.data.doPay">充值点数</dy-button>
					</div>
				</div>
				<div style="color:rgb(233, 171, 102)">{{props.data.desc}}</div>
			</div>
		</dy-dialog>
		
		<!-- 场景单选弹窗 -->
		<dy-dialog ref="panos" v-slot="props">
			<div class="panos-list dialog-pano-list" v-if="props.data.panos">
				<div>
					<!-- <div class="panoId-item" v-for="(item,index) in props.data.panos" @click="props.data.index!=index ? (props.data.seletedItem=item,props.data.index=index) : (props.data.seletedItem=[],props.data.index=-1); props.data.select(index)">
						<dy-checkbox :modelValue="props.data.index == index"></dy-checkbox>
						<div class="list-img" :style="'background-image:url('+dyEditor.pano.preview.pano(item.id)+')'"></div>
						<div style="flex: 1;text-align: left;">{{item.name}}</div>
						<div style="color:#656565;">{{formatTime(item.update_time)}}</div>
					</div> -->
					<div class="panoId-item-icon" v-for="(item,index) in props.data.panos" @click="props.data.index!=index ? (props.data.seletedItem=item,props.data.index=index) : (props.data.seletedItem=[],props.data.index=-1); props.data.select(index)">
						<div class="list-img" :style="'background-image:url('+dyEditor.pano.preview.pano(item.id)+')'">
							<dy-checkbox class="pano-checkbox"
								:modelValue="props.data.index == index"></dy-checkbox>
							<div class="select-pano-group" v-if="props.data.groups" :title="'分组：'+getGroupName(item, props.data.groups)">{{getGroupName(item, props.data.groups)}}</div>
						</div>
						<div class="pano-item-name">{{item.name}}</div>
					</div>
				</div>
			</div>
		</dy-dialog>
		
		<!-- 场景多选弹窗 -->
		<dy-dialog ref="panos2" v-slot="props">
			<div class="panoId-item" style="flex-shrink: 0;background-color: #1f1f1f;" v-if="props.data.panos" @click="props.data.selectAll()">
				<!-- <dy-checkbox :modelValue="(props.data.selected.length==props.data.panos.length) + (props.data.selected.length>0 && props.data.selected.length<props.data.panos.length)*2">全选</dy-checkbox> -->
				<dy-checkbox :modelValue="props.data.panos.length>0 && props.data.selected.length>=props.data.panos.length">全选</dy-checkbox>
			</div>
			<div class="panos-list" v-if="props.data.panos">
				<div>
					<!-- <div class="panoId-item" v-for="item in props.data.panos" @click="props.data.select(item.id)">
						<dy-checkbox :modelValue="props.data.selected.indexOf(item.id)>=0"></dy-checkbox>
						<div class="list-img" :style="'background-image:url('+dyEditor.pano.preview.pano(item.id)+')'"></div>
						<div style="flex: 1;text-align: left;">{{item.name}}</div>
						<div>{{formatTime(item.update_time)}}</div>
					</div> -->
					
					<div class="panoId-item-icon" v-for="item in props.data.panos" @click="props.data.select(item.id)">
						<div class="list-img" :style="'background-image:url('+dyEditor.pano.preview.pano(item.id)+')'">
							<dy-checkbox class="pano-checkbox"
								:modelValue="props.data.selected.indexOf(item.id)>=0"></dy-checkbox>
						</div>
						<div class="pano-item-name">{{item.name}}</div>
					</div>
				</div>
			</div>
		</dy-dialog>
		
		<!-- AI生成场景选择框 -->
		<dy-dialog ref="ai" v-slot="props">
			<div class="panoId-item" style="flex-shrink: 0;background-color: #1f1f1f;" v-if="props.data.panos" @click="props.data.selectAll()">
				<dy-checkbox :modelValue="(props.data.selected.length==props.data.panos.length) + (props.data.selected.length>0 && props.data.selected.length<props.data.panos.length)*2">全选</dy-checkbox>
			</div>
			<div class="panos-list" v-if="props.data.panos">
				<div>
					<!-- <div class="panoId-item" v-for="item in props.data.panos" @click="props.data.select(item.id)">
						<dy-checkbox :modelValue="props.data.selected.indexOf(item.id)>=0"></dy-checkbox>
						<div class="list-img" :style="'background-image:url('+dyEditor.pano.preview.pano(item.id)+')'"></div>
						<div style="flex: 1;text-align: left;">{{item.name}}</div>
						<div>{{formatTime(item.update_time)}}</div>
					</div> -->
					
					<div class="panoId-item-icon" v-for="item in props.data.panos" @click="props.data.select(item.id)">
						<div class="list-img" :style="'background-image:url('+dyEditor.pano.preview.pano(item.id)+')'">
							<dy-checkbox class="pano-checkbox"
								:modelValue="props.data.selected.indexOf(item.id)>=0"></dy-checkbox>
						</div>
						<div class="pano-item-name">{{item.name}}</div>
					</div>
				</div>
			</div>
		</dy-dialog>
		
		<!-- AI生成多选场景弹窗 -->
		<dy-dialog ref="panos3" v-slot="props">
			<div class="panoId-item" style="flex-shrink: 0;background-color: #1f1f1f;" v-if="props.data.panos" @click="props.data.selectAll()">
				<!-- <dy-checkbox :modelValue="(props.data.selected.length==props.data.panos.length) + (props.data.selected.length>0 && props.data.selected.length<props.data.panos.length)*2">全选</dy-checkbox> -->
				<dy-checkbox :modelValue="props.data.panos.length>0 && props.data.selected.length>=props.data.panos.length">全选</dy-checkbox>
			</div>
			<div class="panos-list" v-if="props.data.panos">
				<div>
					<!-- <div class="panoId-item" v-for="item in props.data.panos" @click="props.data.select(item.id)">
						<dy-checkbox :modelValue="props.data.selected.indexOf(item.id)>=0"></dy-checkbox>
						<div class="list-img" :style="'background-image:url('+dyEditor.pano.preview.pano(item.id)+')'"></div>
						<div style="flex: 1;text-align: left;">{{item.name}}</div>
						<div style="display:flex;align-items: center;">
							关联点位：
							<dy-button style="margin-right:20px;color:#61afef" @click.stop="props.data.selectRefer(item)">{{item.refer ? props.data.panos.find(v=>v.id==item.refer).name : "自动"}}</dy-button>
						</div>
						<div>{{formatTime(item.update_time)}}</div>
					</div> -->
					
					<div class="panoId-item-icon" v-for="item in props.data.panos" @click="props.data.select(item.id)">
						<div class="list-img" :style="'background-image:url('+dyEditor.pano.preview.pano(item.id)+')'">
							<dy-checkbox class="pano-checkbox"
								:modelValue="props.data.selected.indexOf(item.id)>=0"></dy-checkbox>
							
							<div class="pano-item-name bind-name" 
								@click.stop="props.data.selectRefer(item)">
								<dy-icon icon="icon-link-two"
									style="margin-left:5px;"
									tooltip="关联点位"></dy-icon>
								{{item.refer ? props.data.panos.find(v=>v.id==item.refer).name : "自动"}}
							</div>
						</div>
						<div class="pano-item-name">{{item.name}}</div>
					</div>
				</div>
			</div>
		</dy-dialog>
		
		<!-- 发布成功弹窗 -->
		<dy-dialog ref="publishSuccess" v-slot="props">
			<div class="pub-item">
				<div>作品发布成功，发布后的地址不会发生变更，请放心分享。</div>
				<div style="display: flex">
					<div class="url-box">{{props.data.url}} <span @click="props.data.copy(props.data.url)">复制地址</span></div>
					<dy-button class="active open-window" @click="props.data.openUrl(props.data.url)">新窗口打开</dy-button>
				</div>
			</div>
		</dy-dialog>
		
		<!-- 新手素材包 -->
		<dy-dialog ref="beginnerSource" v-slot="props">
			<div style="width: 460px;margin-top: 20px;">
				“下载新手素材包”可获取一套官方提供的全景素材包，点击“创建作品”从上传素材开始，体验整个制作流程。<br>
				“创建体验作品”则是基于官方提供的全景素材，自动创建作品，省去上传流程，直接体验编辑工具功能。
			</div>
			<div class="body-botton-group" >
				<dy-button class="active" style="margin-right: 10px;" @click="props.data.download">下载新手素材包</dy-button>
				<dy-button class="active" @click="props.data.create">创建体验作品</dy-button>
			</div>
		</dy-dialog>
		
		<!-- 需求定制 -->
		<dy-dialog ref="demand" v-slot="props">
			<div style="font-size: 18px;">扫描二维码添加顾问，了解定制详情</div>
			<div class="demand-img" style="background-image: url(./static/editor/demand.jpg);"></div>
			<div style="width: 460px;color: #909090;">如果当前的项目模板，或编辑工具中的功能无法满足你的商业项目需求时，我们可为你提供个性化的功能需求定制服务！</div>
		</dy-dialog>
		<!-- 帮助弹窗 -->
		<dy-dialog ref="help" v-slot="props">
			<iframe class="help-iframe" frameborder="0" :src="props.data.url"></iframe>
		</dy-dialog>
		
		<!-- 编辑全景名称弹窗 -->
		<dy-dialog ref="editName" v-slot="props">
			<dy-input class="edit-name" maxlength="50" v-model="props.data.name" placeholder="请输入作品名称"/>
		</dy-dialog>
		
		<!-- 空间不足弹窗3 -->
		<dy-dialog ref="storage3" v-slot="props">
			<div v-if="props.data.storage">
				<div class="title">空间容量不足，无法导入三维模型</div>
				<div class="storage-info">
					<div>导入的三维模型大小为：{{(props.data.storage.tourSize / 1024 / 1024).toFixed(2)||0}}MB，已超出当前空间的总容量。</div>
					<div>在作品管理列表中删除一些无用的作品，以释放空间或升级增值服务。</div>
					<div class="storage-button">
						<div @click="props.data.storage.goProject">去管理作品</div>
						<div @click="props.data.storage.goShop">去查看增值服务</div>
					</div>
				</div>
			</div>
		</dy-dialog>
		
		<!-- 列表页移动作品弹窗 -->
		<dy-dialog ref="moveProject" v-slot="props">
			<div class="tour-title" style="cursor:pointer;" @click="props.data.goFolder(null,0)">
				<div>
					<dy-icon icon="icon-folder-close-filled" 
						:style="{color:!props.data.folderId?'rgb(99, 120, 231)':''}"></dy-icon>
					根目录
				</div>
			</div>
			<div class="tour-list-box">
				<div class="folder-list">
					<editor-folder-item v-for="(item,key) in props.data.folders" 
						:data="item"
						:fid="key"
						:root="true"
						:level="0"
						:active="props.data.folderId"
						@clickItem="props.data.goFolder"
						@removeItem="props.data.folderRemove">
					</editor-folder-item>
				</div>
				<!-- <div class="no-folder" v-if="props.data.folders.length==0">
					<div class="no-folder-text">
						当前目录没有更多文件夹可选<br><span>你可以在当前目录创建新的文件夹或把作品移动到当前位置中</span>
					</div>
				</div>
				
				<div class="tour-item" v-for="(item,index) in props.data.folders" :key="index" @click="props.data.itemClick(item)">
					<div class="item-img" ></div>
					<div class="item-name" >{{item.name}}</div>
					<div class="tour-time">{{formatTime(item.update_time)}}</div>
				</div> -->
			</div>
		</dy-dialog>
		
		<!-- 列表页创建文件夹,移动文件夹里需要再次打开并且覆盖在移动弹窗上，所以创建放在移动弹窗下面 -->
		<dy-dialog ref="createFolder" v-slot="props">
			<dy-input class="edit-name" maxlength="50" v-model="props.data.name" placeholder="请输入文件夹名称" @input="props.data.name.length>0 ? $refs.createFolder.enableConfirm() : $refs.createFolder.disableConfirm()"/>
		</dy-dialog>
		
		<!-- 离线下载弹窗 -->
		<dy-dialog ref="offlinePack" v-slot="props">
			<div class="download-list-box" >
				<div class="no-folder" v-if="props.data.list.length==0">
					<i class="iconfont icon-download-two" style="font-size:100px;"></i>
					<div class="no-folder-text">
						暂无离线作品<br><br><span>离线作品支持将DY3D作品下载到本地查看，<br>并支持将离线包数据部署到自有服务器以自己的域名进行在线查看。</span>
					</div>
				</div>
				<div class="offline-item" v-for="(item,index) in props.data.list" :key="index" >
					<div style="display: flex;justify-content: space-between;width: 100%;">
						<div class="item-name" style="max-width: 530px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">{{item.name}}</div>
						<div class="tour-time">{{formatTime(item.create_time)}}</div>
					</div>
					<div style="display: flex;justify-content: space-between;width: 100%;">
						<div class="text-download" v-if="item.status==2" >
							<div style="margin-right: 20px;" 
								v-for="num in item.files" 
								:key="num" 
								@click="props.data.itemClick(item,num)">{{item.files==1?'离线包下载':'离线分卷包'+num}}</div>
						</div>
						<div class="item-name" v-if="item.status<2" style="color: #909090;">正在创建离线包，请稍后...</div>
						<div class="item-name" v-if="item.status==3" style="color: darkred;">离线包创建失败：{{item.error}}</div>
						<div style="color: rgb(250,108,14);font-size: 12px;" v-if="item.status==2&&item.files>1">请把全部离线分包下载后，再进行解压</div>
					</div>
				</div>
			</div>
		</dy-dialog>
		
		<!-- 离线下载无权限 -->
		<dy-dialog ref="offlineNone" v-slot="props">
			<div class="title">升级专业版后即可使用</div>
			<div class="storage-info">
				<div style="line-height: 25px;">该功能允许把制作好的作品打包并下载到本地，支持本地观看，也可上传至自己的服务器中。</div>
				<div class="storage-button" >
					<div style="margin: 5px 10px;" @click="props.data.download">下载示例离线包</div>
					<div style="color: #1a1a1a;cursor: default;margin: 5px 10px;">提取码：1234</div>
				</div>
			</div>
		</dy-dialog>
		
		<!-- 高德地图弹框 -->
		<dy-dialog class="amap" ref="amap" v-slot="props">
			<div id="amapDiv"></div>
		<!-- 	<div id="switchMap">
				<span :class="{'active': props.data.mode==0}" @click="props.data.mode=0;props.data.changeMode(0)">地图</span>
				<span :class="{'active': props.data.mode==1}" @click="props.data.mode=1;props.data.changeMode(1)">卫星</span>
			</div> -->
		</dy-dialog>
		
		<!-- 文章编辑弹框 -->
		<dy-dialog class="docs" ref="docs" v-slot="props">
			<div class="doc-title-bar">
				<span style="width: 70px;text-align: left;">文章标题</span>
				<dy-input 
					class="docs-title" 
					maxlength="50" 
					v-model="props.data.doc.name"></dy-input>
				<span>
					<span class="docs-cover-text">
						文章封面<br>
						<p style="color:#909090;font-size:10px;">512x512</p>
					</span>
					<dy-icon 
						v-if="!props.data.doc.cover"
						class="docs-cover" 
						icon="icon-upload-one" 
						@click="props.data.uploadCover"></dy-icon>
						
					<span 
						v-if="props.data.doc.cover"
						class="docs-cover" 
						:style="'background-image:url('+props.data.doc.cover+')'"
						@click="props.data.uploadCover"> </span>
				</span>
			</div>
			
			<dy-wangEditor class="docs-editor" v-model="props.data.doc.content"></dy-wangEditor>
		</dy-dialog>
		
		<!-- 社区展示弹窗 -->
		<dy-dialog ref="forum" v-slot="props">
			<div class="title">{{props.data.docs.title}}</div>
			<div class="storage-info">
				<div style="white-space: pre-wrap;">{{props.data.docs.text}}</div>
				<div class="storage-button" >
					<div style="margin-top: 10px;" @click="props.data.goEditor">编辑作品</div>
				</div>
			</div>
		</dy-dialog>
		
		<!-- 小程序验证 -->
		<dy-dialog ref="createminiProgram" v-slot="props">
			<div class="miniProgram-box">
				<div class="miniProgram-item">
					<span>请选择平台<b>※</b></span>
					<!-- <span class="miniProgram-help">验证教程</span> -->
				</div>
				<dy-select class="fov-type" :disable="props.data.miniProgram.typeLock" v-model="props.data.miniProgram.type" @change="props.data.typeChange">
					<a value=0>微信小程序</a>
					<a value=1>抖音小程序</a>
					<a value=2>支付宝小程序</a>
					<a value=3>百度小程序</a>
				</dy-select>
				<div class="miniProgram-item">
					<span>校验文件<b>※</b></span>
				</div>
				<div class="miniProgram-item" style="margin-bottom: 20px;">
					<div class="miniProgram-file-name" :class="{'have-file':props.data.miniProgram.auth}">
						{{!props.data.miniProgram.auth ? (props.data.miniProgram.type=='3'?'请上传 .html 格式的文件':'请上传 .txt 格式的文件'):props.data.miniProgram.auth}}
					</div>
					<dy-button :disable="props.data.miniProgram.authLock" class="active" style="width:105px;height:40px;line-height:40px;margin:0 0 0 10px;" @click="props.data.upload">上传校验文件</dy-button>
				</div>
				<div class="miniProgram-item">
					<span>小程序名称<b>※</b></span>
				</div>
				<dy-input class="white miniProgram-name"
					maxlength="50" :number="false"
					v-model="props.data.miniProgram.name" 
					@input="props.data.input"
					placeholder="请填写小程序全称"></dy-input>
					
				<div class="miniProgram-item">
					<span>申请小程序原因</span>
				</div>
				<textarea spellcheck="false"
					class="miniProgram-reason"
					v-model="props.data.miniProgram.reason" 
					maxlength="500" 
					placeholder="请填写申请小程序验证原因" 
					placeholder-style="color:#909090"
					></textarea>
			</div>
		</dy-dialog>
		
		<!-- 小程序验证成功弹窗 -->
		<dy-dialog ref="miniProgramSuccess" v-slot="props">
			<div class="pub-item" style="align-item: center;">
				<div style="text-align: center;font-size: 18px;">成功创建小程序验证地址</div>
				<div style="margin: 10px 0 0 20px;">复制以下地址到要验证的第三方小程序验证中即可进行验证</div>
				<div style="display: flex">
					<dy-input :number="false" :readonly="true" :clear="false"
						class="url-box" style="width:650px;margin-right: 10px !important;background-color: #fff;color:#1a1a1a" :model-value="props.data.url"></dy-input>
					<dy-button class="active" style="width:55px;height:40px;line-height:40px;margin:0;text-align: center;" 
						@click="props.data.copy(props.data.url)">复 制</dy-button>
				</div>
			</div>
		</dy-dialog>
		
		<!-- 小程序高级服务 -->
		<dy-dialog ref="miniProgramService" v-slot="props">
			<div class="miniProgram-box">
				<div class="miniProgram-item">
					<span>请勾选服务类型<b>※</b></span>
				</div>
				<div class="miniProgram-check-area">
					<div>
						<div style="display: flex;padding-top: 20px;" @click="props.data.selectName">
							<dy-checkbox :modelValue="props.data.service.origin" ></dy-checkbox>
							小程序域名定制
						</div>
						<div class="miniProgram-check-tips" @click="props.data.selectName">可针对小程序验证后的域名 进行订制（详询客服） 例如:
														<br>原域名： https://a8738facd.dy3d.net
														<br>自定义域名： https://<b>demovr</b>.dy3d.net（<b>demovr</b>为订制内容）
						</div>
						<div style="display: flex;padding-top: 20px;" @click="props.data.selectAllsite">
							<dy-checkbox :modelValue="props.data.service.public" ></dy-checkbox>
							小程序调用全站DY3D作品
						</div>
						<div class="miniProgram-check-tips" 
							style="border: none;margin-bottom: 0;padding-bottom: 20px;" @click="props.data.selectAllsite">
							允许调用全站的DY3D作品，在调用非本账户作品时，会显示创作者名称
						</div>
					</div>
				</div>
				<div class="miniProgram-item">
					<span>请填写申请原因（如填写定制域名的名称，或调用全站作品的原因）<b>※</b></span>
				</div>
				<textarea spellcheck="false"
					class="miniProgram-reason" style="height: 70px;"
					v-model="props.data.service.reason" 
					@input="props.data.input"
					maxlength="500" 
					placeholder="请详细描述申请的原因" 
					placeholder-style="color:#909090"
					></textarea>
				<div class="miniProgram-item">
					<span>留下你的联系电话，客服将在3个工作日内联系你<b>※</b></span>
				</div>
				<dy-input class="white miniProgram-name" style="margin-bottom: 0;"
					maxlength="50" :number="false"
					v-model="props.data.service.phone" 
					@input="props.data.input"
					placeholder="请填写联系电话"></dy-input>
			</div>
		</dy-dialog>
		
		<!-- 创建体验项目弹窗 -->
		<dy-dialog ref="createDemo" v-slot="props">
			<div style="text-align:center;">
				<div v-if="props.data.status!=3 && props.data.status!=4">
					  <div class="load-container">
					    <div class="loader-bounce"></div>
					  </div>
				</div>
				
				<div class="build-status-icon iconfont "
					:class="props.data.status==3 ? 'icon-success-filled' : 'icon-error-filled'"
					v-if="props.data.status>=3"></div>
						
				<div class="build-status-title">
					{{props.data.status==3?'创建成功，点击完成跳转编辑':(props.data.status==4?props.data.msg:'正在创建中，请勿操作')}}</div>
			</div>
		</dy-dialog>
		
		<!-- 复制项目弹窗 -->
		<dy-dialog ref="copyProject" v-slot="props">
			<div style="text-align:center;">
				<div v-if="props.data.status!=3 && props.data.status!=4">
					  <div class="load-container">
					    <div class="loader-bounce"></div>
					  </div>
				</div>
				
				<div class="build-status-icon iconfont "
					:class="props.data.status==3 ? 'icon-success-filled' : 'icon-error-filled'"
					v-if="props.data.status>=3"></div>
					
				<div class="build-status-title" v-if="props.data.status<3">{{'已复制'+props.data.percent+'%'}}</div>
				<div class="build-status-text" v-if="props.data.status<3">复制作品的时间依据数据大小决定，数据越大复制时间越长</div>
				<div class="build-status-title" >
					{{props.data.status==3?'复制作品成功'
					:(props.data.status==4?props.data.msg:'')}}</div>
			</div>
		</dy-dialog>
		
		<!-- 更新弹窗 -->
		<dy-dialog ref="versionImg" v-slot="props">
			<img src="/static/editor/version-img.png?2" class="version-img">
		</dy-dialog>
		
		<!-- 导览背景音乐弹窗 -->
		<dy-dialog ref="naviBgm" v-slot="props">
			<div class="bgm-item">
				背景音乐
				<div style="color:rgb(99, 120, 231);cursor: pointer;" @click="props.data.clear">清空</div>
			</div>
			<div class="bgm-item">
				<dy-input class="bgm-name" 
					:readonly="true" 
					:type="'number'"
					:number="false"
					v-model="props.data.name" 
					:clear="false"
					placeholder="还未上传音乐"/>
				<dy-button class="active" style="width:100px;height: 100%;line-height: 40px;" @click="props.data.upload">上传音乐</dy-button>
				<dy-button class="active" style="width:100px;height: 100%;line-height: 40px;" @click="props.data.openmusic">系统音乐</dy-button>
			</div>
			<div class="bgm-item">
				音量调节
				<div style="width: 220px;display:flex;justify-content: space-between;">播放次数
					<div style="color: #909090;font-size: 12px;">为 0 时则循环播放</div>
				</div>
			</div>
			<div class="bgm-item">
				<dy-input class="bgm-name" 
					style="width:220px"
					:number="false"
					:type="'number'"
					:clear="false"
					v-model="props.data.volume" 
					placeholder="音量调节"
					:percent="'%'"
					/>
				<dy-input class="bgm-name"
					style="width:220px"
					:clear="false"
					:type="'number'"
					:number="false"
					:percent="'次'"
					v-model="props.data.count" 
					placeholder="播放次数"/>
			</div>
		</dy-dialog>
		
		<!-- AI推演弹窗 -->
		<dy-dialog ref="pano2dyc" v-slot="props">
			<div style="text-align:center;">
				<div v-if="props.data.status<3 || !props.data.status">
					<div class="load-container">
						<div class="loader-bounce"></div>
					</div>
				</div>
				
				<div class="build-status-icon iconfont "
					:class="props.data.status==3 ? 'icon-success-filled' : 'icon-error-filled'"
					v-if="props.data.status>=3"></div>
					
				<div class="build-status-tips" v-if="props.data.status>=3">
					<div class="build-status-title">{{ props.data.status==3 ? '处理成功': '处理失败'}}</div>
					{{props.data.status==3?'':(props.data.msg ? props.data.msg :'发生未知错误.')}}
				</div>
				<div class="build-status-title" v-else>{{ props.data.status == 2 ? 'AI正在生成中.. 请稍候。' : 'AI生成中.. 请稍候。' }}</div>
			</div>
		</dy-dialog>
	</view>
</template>

<script>
	import Icon from '@/common/editor/Icon.js';
	import CustomVirtualList from '@/components/custom-virtual-list/list.vue';
	
	export default {
		name:"dy-modal",
		components: {
		    CustomVirtualList
		},
		data() {
			return {
				IconArr : Icon,
				
			};
		},
		methods:{
			getGroupName(item, groups){
				for(let i=0; i<groups.length; i++){
					const group = groups[i];
					if(group.panoId.findIndex(p=>p==item.id)>-1) 
						return group.name;
				}
			},	
			//标准弹框
			show(params){
				this.$refs.dialog.show(params);
			},
			
			//批量文件提示框
			files(params){
				this.$refs.files.show(params);
			},
			
			//构建项目
			build(params){
				this.$refs.build.show(params);
			},
			
			//发布项目
			publish(params){
				this.$refs.publish.show(params);
			},
			
			//创建联系人
			contact(params){
				this.$refs.contact.show(params);
			},
			
			//图标选择
			icons(params){
				this.$refs.icons.show(params);
			},
			
			//场景单选
			panos(params){
				this.$refs.panos.show(params);
			},
			
			//场景多选
			panos2(params){
				this.$refs.panos2.show(params);
			},
			
			//AI生成场景多选
			panos3(params){
				this.$refs.panos3.show(params);
			},
			
			//空间不足
			storage(params){
				this.$refs.storage.show(params);
			},
			
			//空间不足2
			storage2(params){
				this.$refs.storage2.show(params);
			},
			
			//空间不足3
			storage3(params){
				this.$refs.storage3.show(params);
			},
			
			//发布成功
			publishSuccess(params){
				this.$refs.publishSuccess.show(params);
			},
			
			//新手素材包
			beginnerSource(params){
				this.$refs.beginnerSource.show(params);
			},
			//需求定制
			demand(params){
				this.$refs.demand.show(params);
			},
			//帮助
			help(params){
				this.$refs.help.show(params);
			},
			
			//修改全景名称
			editName(params){
				this.$refs.editName.show(params);
			},
			
			//列表页创建文件夹
			createFolder(params){
				this.$refs.createFolder.show(params);
			},
			
			//移动作品
			moveProject(params){
				this.$refs.moveProject.show(params);
			},
			
			//离线包弹窗
			offlinePack(params){
				this.$refs.offlinePack.show(params);
			},
			
			//离线下载无权限
			offlineNone(params){
				this.$refs.offlineNone.show(params);
			},
			
			//社区展示弹窗
			forum(params){
				this.$refs.forum.show(params);
			},
			//高德地图弹框
			amap(params){
				this.$refs.amap.show(params);
			},
			
			//文章编辑弹框
			docs(params){
				this.$refs.docs.show(params);
			},
			
			//3D模型选择列表
			models(params){
				this.$refs.models.show(params);
			},
			
			//小程序验证
			createminiProgram(params){
				this.$refs.createminiProgram.show(params);
			},
			
			//小程序验证成功
			miniProgramSuccess(params){
				this.$refs.miniProgramSuccess.show(params);
			},
			
			//小程序高级服务
			miniProgramService(params){
				this.$refs.miniProgramService.show(params);
			},
			
			//创建体验作品
			createDemo(params){
				this.$refs.createDemo.show(params);
			},
			
			//复制作品
			copyProject(params){
				this.$refs.copyProject.show(params);
			},
			
			//ai推演
			pano2dyc(params){
				this.$refs.pano2dyc.show(params);
			},
			
			//ai
			ai(params){
				this.$refs.ai.show(params);
			},
			
			//ai order
			aiOrder(params){
				this.$refs.aiOrder.show(params);
			},
			
			//版本更新
			versionImg(params){
				this.$refs.versionImg.show(params);
			},
			
			//导览背景音乐
			naviBgm(params){
				this.$refs.naviBgm.show(params);
			},
			
			//更新数据
			update(target, params){
				this.$refs[target].update(params);
			},
			enable(target){
				this.$refs[target].enable();
			},
			disable(target){
				this.$refs[target].disable();
			},
			close(target){
				this.$refs[target].close(true);
			}
		}
	}
</script>

<style>
	
	/* 添加联系人弹框 */
	/* .dialog-contacts{
		width:800px;
		height:530px;
		background-color:#fff;
		border-radius:5px;
	} */
	.dialog-contact{
		width: calc(100% - 40px);
		/* height: 400px; */
		height:auto;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-content: center;
		justify-content: center;
		overflow: auto;
		padding: 10px;
		/* margin: 0 20px; */
		box-sizing: border-box;
		align-items: center;
	}

	.contact-face{
		width:100px;
		height:100px;
		background-color:#161619;
		background-size:cover;
		background-repeat: no-repeat;
		background-position: center center;
		margin:10px;
		margin-top:0;
		line-height: 100px;
		padding-top: 10px;
		box-sizing: border-box;
		text-align: center;
		position: relative;
		border-radius:25px;
	}
	.contact-face div{
		position: absolute;
		height:20px;
		line-height:20px;
		width:60px;
		bottom:5px;
		left:20px;
		border-radius: 3px;
		color:#333;
		/* background-color:#909090; */
	}
	.contact-face span{
		font-size: 44px;
		line-height: 60px;
		color: #909090;
	}
	.contact-text{
		width: 100px;
		height: 40px;
		line-height: 40px;
		color: #909090;
		text-align: center;
		margin:auto;
		font-size:12px;
	}
	.right-body-box{
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		width: 440px;
		height: 200px;
	}
	.contact-input-box{
		display: flex;
		width:100%;
		height:40px;
		line-height:40px;
		margin:10px;
	}
	.contact-input{
		/* border: 1px solid #efefef;
		height:40px;
		line-height:40px;
		box-sizing: border-box;
		padding:0px 10px;
		font-size: 14px;
		background-color: #fff; */
		width:100%;
		text-align: left;
	}
	/*图标选择弹框*/
	.hotspot-icons{
		width:100%;
		height:calc(100%);
		box-sizing: border-box;
		display: flex;
		justify-content: flex-start;
		align-content: flex-start;
		flex-wrap: wrap;
		/* overflow-y: auto; */
	}
	.hotspot-icons span{
		font-size: 16px;
	}
	.hotspot-icons-types{
		margin: 0 0px 10px 0px;
		padding: 10px;
		box-sizing: border-box;
		width: 100%;
		line-height: 28px;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		/* background-color: #f8f8f8; */
		/* border-bottom: 1px solid #efefef; */
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: flex-start;
	}
	.hotspot-icons-types-row{
		width:100%;
		flex:1;
		display:flex;
		flex-direction: row;
	}
	.hotspot-icons-types span{
		color: #909090;
		font-size: 14px;
		margin-right: 15px;
		flex-shrink: 0;
	}
	.hotspot-icons-types span:hover{
		cursor: pointer;
	}
	.icons_span_box{
		width: calc(100% - 50px);
		display: flex;
		justify-content: flex-start;
		align-content: flex-start;
		flex-wrap: wrap;
	}
	.icon-span-active{
		color: rgb(99, 120, 231) !important;
	}
	.icon{
		width:76px;
		height:76px;
		color: #fff;
		display:inline-block;
		margin:0 12px 15px 12px;
		background-color:#2f2f2f;
		background-size: 50px;
		background-position: center center;
		background-repeat: no-repeat;
		/* padding:5px; */
		border-radius:5px;
		cursor: pointer;
		border:2px solid transparent;
	}
	.icon:hover{
		/* border:2px solid rgb(99, 120, 231); */
	}
	.icon.active{
		border:2px solid rgb(99, 120, 231);
	}
	.icon.frame{
		position:relative;
	}
	.icon.frame:after{
		content:' ';
		position:absolute;
		display:block;
		right:0;
		bottom:0;
		width:16px;
		height:16px;
		background-size:100%;
		background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAALRJREFUWEftlsEJhTAMhv/cHEHoYq7hJI7oqeAI7xZRiEigRnmSeEhvJU3z52vSlhA8KDg+UkASSAIHAWYeAEwAeqfWXACMuwBm7gDMjsElx+VMgM+Zl1IuQdRad7us0/OWs6wT+/cFaMU6sxYBy+82AWsjNwG6Jp7WQCsRswZaxeUuQM7MQq7t1p1ym0CYAKufLSJ/E3AR8JWrOO4xEswbCSL6Wef2hl1i5YckCSSBJBBOYAXKm6prrtGJVwAAAABJRU5ErkJggg==');
	}
	.icon span{
		display:block;
		width:40px;
		height:40px;
		margin:20px;
		background-size:100%;
	}
	.icon.frame:hover span{
		background-size:100%;
		background-position: 0;
		background-repeat: no-repeat;
		animation: PNGIF 1s steps(23) infinite;
	}
	.icon div{
		width:100%;
		height:100%;
		background-size:100% 100%;
	}
	.all-icon-box{
		flex:1;
		display: flex;
		justify-content: flex-start;
		align-content: flex-start;
		width: 100%;
		flex-wrap: wrap;
		overflow-y: auto;
	}
	
	/*场景选择弹框*/
	/* .dialog-panos{
		width: 100%;
		height: 350px;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-content: flex-start;
		justify-content: flex-start;
		align-items: center;
		overflow: auto;
		padding: 10px;
		box-sizing: border-box;
	}
	.dialog-pano{
		width:96px;
		height:96px;
		background-color:#ccc;
		margin:6px;
		background-size:100px 100px;
		background-position: center center;
		position: relative;
		border:2px solid transparent;
	}
	.dialog-pano span{
		display:block;
		position: absolute;
		bottom:0;
		height:20px;
		line-height:20px;
		overflow:hidden;
		width:100%;
		background-color:rgba(0,0,0,0.3);
		color:#fff;
		font-size:12px;
		text-align: center;
	}
	.dialog-pano:hover{
		border:2px solid rgb(99, 120, 231);
	}
	.dialog-pano.active{
		border:2px solid rgb(99, 120, 231);
	} */
	.panoId-item-icon{
		width: 110px;
		height: 110px;
		box-sizing: border-box;
		position: relative;
		display:inline-block;
		margin:10px;
	}
	.panoId-item-icon .list-img{
		width:100%;
		height:100%;
		border-radius:5px;
		position: relative;
		overflow: hidden;
	}
	
	.panoId-item-icon .pano-checkbox{
		position: absolute;
		left:5px;
		top:5px;
		height:18px;
	}
	.panoId-item{
		padding: 0 10px;
		width: 100%;
		height: 50px;
		box-sizing: border-box;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.panoId-item:last-child{
		border: none;
	}
	.panoId-item:hover{
		background-color: #1f1f1f;
	}
	.pano-item-name{
		flex: 1;
		text-align:left;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.pano-item-name.bind-name{
		position: absolute;
		background-color:rgba(0,0,0,0.5);
		bottom:0;
		width:100%;
		cursor:pointer;
	}
	.list-img{
		width:32px;
		height: 32px;
		background-size: 100% 100%;
		margin-right: 10px;
	}
	.panos-list{
		width:100%;
		height:100%;
		overflow:auto;
		text-align: left;
	}
	.pub-item{
		width: 100%;
		height: 100%;
		display:flex;
		flex-direction: column;
		align-content: flex-start;
		justify-content: center;
	}
	.pub-item div{
		font-weight:500;
		text-align:left;
		margin : 10px 20px;
	}
	.url-box{
		width: 610px;
		margin: 0 20px 0 0 !important;
		padding:0 10px;
		box-sizing:border-box;
		height: 40px;
		line-height:40px;
		border-radius:20px;
		background-color:#202023;
	}
	.url-box span{
		float: right;
		font-size:12px;
		color:rgb(99, 120, 231);
		cursor: pointer;
	}
	.build-status-title{
		font-size:18px;
		margin-bottom:10px;
		margin-top:15px;
	}
	.build-status-text{
		font-size:14px;
	}
	.storage-info,
	.storage-info div{
		text-align: center;
	}
	.storage-button div{
		display:inline-block;
		color:rgb(99, 120, 231);
		cursor: pointer;
		margin:15px;
	}
	.edit-name{
		height: 40px;
		width: calc(100% - 40px);
		text-align: left;
	}
	.tour-title{
		width: 100%;
		height: 50px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background-color: #1a1a1a;
		padding: 0 20px;
		box-sizing: border-box;
	}
	.tour-title i{
		color: #909090;
	}
	.tour-list-box{
		width: 100%;
		height: calc(100% - 50px);
		padding:0 10px;
		box-sizing: border-box;
	}
	.tour-list-box .tour-item{
		padding-left:10px;
		box-sizing:border-box;
		width: 100%;
		height: 50px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		cursor: pointer;
	}
	.download-list-box{
		height: 100%;
		margin-bottom: 20px;
		box-sizing: border-box;
		overflow: auto;
		width: 100%;
	}
	.download-list-box>>>::-webkit-scrollbar-thumb{
		background-color: #555 !important;
	}
	.offline-item{
		padding:0 20px;
		box-sizing:border-box;
		width: 100%;
		min-height: 85px;
		line-height: 30px;
		border-bottom: 1px solid #2f2f2f;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.tour-item .item-img{
		width: 32px;
		height: 32px;
		margin: 0 10px 0 0;
		background-size: 100% 100%;
	}
	.tour-item .item-name{
		flex: 1;
		text-align: left;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.text-download{
		flex: 1;
		text-align: left;
		color: rgb(99, 120, 231);
		display: flex;
		cursor: pointer;
		flex-wrap: wrap;
	}
	.tour-item .tour-time{
		width: 160px;
		text-align: right;
		color: #656565;
		padding-right: 10px;
		box-sizing: border-box;
	}
	.tour-item:hover,.offline-item:hover{
		background-color: #2f2f2f;
	}
	.no-folder{
		position:absolute;
		left:50%;
		top:50%;
		transform:translate(-50%,-50%);
		width: 380px;
		text-align:center;
		color: #dfdfdf;
	}
	.no-folder i{
		cursor:default;
	}
	.no-folder i:hover{
		color:#909090;
	}
	.no-folder-text{
		margin-top: 35px;
		line-height: 15px;
	}
	.no-folder-text span{
		font-size: 12px;
		color: #909090;
	}
	.title-back{
		color: #909090;
		cursor: pointer;
		margin-right: 5px;
	}
	.title-back:hover{
		color: rgb(99, 120, 231);
	}
	#amapDiv{
		width:100%;
		height:100%;
	}
	#switchMap{
		display:flex;
		flex-direction: row;
		position: absolute;
		right: 40px;
		top: 80px;
	}
	
	#switchMap span{
		background-color:#fff;
		color:#3a3a3a;
		padding:5px 15px;
	}
	
	#switchMap span.active{
		background-color:rgb(99, 120, 231);
		color:#fff;
	}
	#switchMap span:first-child{
		border-radius: 5px 0 0 5px;
	}
	
	#switchMap span:last-child{
		border-radius: 0 5px 5px 0;
	}
	
	.doc-title-bar{
		width: 100%;
		display:flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
		padding:10px;
		box-sizing: border-box;
	}
	.docs-cover{
		display: inline-block;
		width: 40px;
		margin-left: 10px;
		vertical-align: middle;
		line-height: 40px;
		height: 40px;
		background-color: #F8F8F8;
		background-repeat: no-repeat;
		background-size: cover;
		border-radius:15px;
	}
	.docs-cover:hover{
		color:#606060;
	}
	.docs-editor{
		flex:1;
		width:100%;
		color:#333;
	}
	.docs-title{
		flex:1;
		border:0;
		text-align: left;
	}
	.docs-cover-text{
		display: inline-block;
		vertical-align: middle;
		width: 100px;
		text-align: left;
		padding-left: 20px;
	}
	.miniProgram-box{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		padding: 20px;
		padding-top: 10px;
		box-sizing: border-box;
	}
	.miniProgram-item{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		height: 40px;
		width: 100%;
	}
	.miniProgram-item b{
		color: rgb(99, 120, 231);
		margin: 0 10px 0 5px;
		width: 20px;
		height: 100%;
		line-height: 40px;
	}
	.miniProgram-item i{
		color: rgb(99, 120, 231);
		margin: 0 10px 0 5px;
		width: 20px;
		height: 100%;
		line-height: 40px;
	}
	.miniProgram-help{
		color: rgb(99, 120, 231);
		cursor: pointer;
	}
	.miniProgram-box>>>.dy-select-main{
		background-color: #fff;
		border: 1px solid #efefef;
		height: 40px;
		line-height: 40px;
		margin-bottom: 20px;
	}
	.miniProgram-box>>>.dy-select-text{
		text-align: left;
	}
	.miniProgram-file-name{
		flex: 1;
		background: #F8F8F8;
		border-radius: 5px;
		border: 1px solid #EFEFEF;
		height: 100%;
		line-height: 40px;
		text-align: left;
		padding: 0 10px;
		box-sizing: border-box;
		color: #909090;
	}
	.miniProgram-file-name.have-file{
		color: #1a1a1a;
	}
	.miniProgram-name{
		width: 100%;
		height: 40px;
		line-height: 40px;
		text-align: left;
		margin-bottom: 20px;
		color: #1a1a1a;
	}
	.miniProgram-reason{
		width: 100%;
		height: 100px;
		border: 1px solid #EFEFEF;
		box-sizing: border-box;
		text-align: left;
		padding: 10px;
		border-radius: 5px;
		color: #1a1a1a;
	}
	.miniProgram-check-area{
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
		background-color: #F8F8F8;
		display: flex;
		flex-direction: column;
		border-radius: 5px;
		cursor: pointer;
	}
	.miniProgram-check-tips{
		line-height: 16px;
		color: #909090;
		font-size: 12px;
		text-align: left;
		padding-top: 10px;
		padding-bottom: 20px;
		box-sizing: border-box;
		border-bottom: 1px solid #efefef;
	}
	.miniProgram-check-tips b{
		color: rgb(99, 120, 231);
	}
	.demand-img{
		width: 130px;
		height: 130px;
		margin: 20px 0;
		background-size: 100% 100%;
	}
	.body-botton-group{
		display: flex;
		width: 100%;
		justify-content: center;
		margin-top: 20px;
		padding-top: 20px;
		padding-right: 10px;
		box-sizing: border-box;
		border-top: 1px solid #efefef;
	}
	.version-img{
		object-fit: contain;
		width: 100%;
	}
	.bgm-item{
		font-size: 14px;
		width: 100%;
		height : 40px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.bgm-name{
		color:#1a1a1a;
		width : 240px;
		height : 100%;
		line-height: 40px;
		background-color: #fff;
		text-align:left;
		border: 1px solid #efefef;
	}
	.bgm-name>>>i{
		font-style: normal !important;
		cursor: unset !important;
		color: #909090 !important;
	}
	.bgm-name>>>.uni-input-placeholder{
		color: #909090;
		font-size: 14px;
	}
	.open-window{
		width:90px;
		height:40px !important;
		line-height:40px !important;
		margin:0 !important;
		border-radius:20px !important;
		flex-shrink: 0;
	}
	.ai-order{
		background-color: #2f2f2f;
		border-radius: 25px;
		overflow:hidden;
		line-height:35px;
		display:flex;
	}
	.ai-order-title{
		display:flex;
		flex-direction:row;
		align-items: center;
		justify-content: space-between;
		font-size:16px;
		height:35px;
		line-height:35px;
		background-color:#222;
	}
	.pay-balance{
		font-size:20px;
	}
	.pay-radiobox{
		position:relative;
		margin: 0 !important;
		margin-left: 10px !important;
		padding-left:25px;
		cursor:pointer;
	}
	.pay-radiobox:before{
		content:'';
		position:absolute;
		display:block;
		font-family:iconfont;
		left:0;
		top:2px;
		width:18px;
		height:18px;
		text-align: center;
		line-height:18px;
		font-size:18px;
		background-color:rgba(0,0,0,0.5);
		border-radius: 5px;
	}
	.pay-radiobox.active:before{
		content:'\ea84';
		background: linear-gradient(-45deg, #7d65f8, #3999ca);
		color:#fff;
	}
	.ai-balance{
		display:flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
		background: rgba(0, 0, 0, 0.25);
		border-radius: 25px;
	}
	.ai-select-pano{
		width:100px;
		text-align:center !important;
		margin:0 !important;
		background-color: rgba(255,255,255,0.03) !important;
	}
	.ai-select-pano:hover{
		background-color: rgba(255,255,255,0.05) !important;
	}
	
	.ai-order-title-info{
		font-size:14px;
		flex: 1;
		text-align: right;
		color:rgb(221, 48, 112);
	}
	.buy-score{
		text-align: center !important;
		width:100px;
		background-color: #e9ab66;
	}
	.buy-score.active{
		background: #e99745 !important;
	}
	.buy-score.active:hover{
		background: #e9ab66 !important;
	}
	.buy-score.active:active{
		background: #e99745 !important;
	}
	.select-pano-group{
		width: 100%;
		position: absolute;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		padding:0 5px;
		box-sizing: border-box;
	}
</style>
